import { Grid } from "@mui/material";
import BuildingTable from "./components/building-table/BuildingTable";
import HeaderBuilding from "./components/header-building/HeaderBuilding";

const BuildingStepForm = () => {
  return (
    <Grid container alignContent="flex-start">
      <Grid item xs={12} my={2}>
        <HeaderBuilding />
      </Grid>
      <Grid item xs={12} my={2}>
        <BuildingTable />
      </Grid>
    </Grid>
  );
};

export default BuildingStepForm;
